import Nullstack from 'nullstack';
export default function IconTextDirectionLtr({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-text-direction-ltr",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 19h14"
  }), "   ", Nullstack.element("path", {
    d: "M17 21l2 -2l-2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 15v-11"
  }), "   ", Nullstack.element("path", {
    d: "M10 15v-11"
  }), " ");
}